import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(isSameOrBefore)

export function ago(date: string | Date): string {
  const now = dayjs()
  const targetDate = dayjs(date)
  const daysAgo = now.diff(targetDate, 'day')

  if (now.isSame(targetDate, 'day')) {
    return targetDate.format('HH:mm')
  }

  if (daysAgo <= 5) {
    return targetDate.fromNow()
  }

  if (now.year() === targetDate.year()) {
    return targetDate.format('D MMM HH:mm')
  }

  return targetDate.format('D MMM YYYY HH:mm')
}
